/**
 * Lobby providers query hook.
 *
 * Fetches the provider list, filters to enabled providers, and sorts by game
 * count desc for lobby display. Normalizes to a plain array view-model so the
 * Providers section never shape-guesses.
 */

import { useQuery } from "@tanstack/react-query";
import casinoService from "../../../services/casinoService";
import { queryKeys } from "../../../shared/data/queryKeys";
import { normalizeQueryError } from "../../../shared/data/errors";

const gameCountOf = (p) => p.game_count ?? p.gameCount ?? 0;

export function useLobbyProviders() {
  return useQuery({
    queryKey: queryKeys.games.providers(),
    queryFn: async () => {
      try {
        const resp = await casinoService.getProviders();
        const enabled = (resp.providers || []).filter((p) => p.is_enabled);
        return [...enabled].sort((a, b) => gameCountOf(b) - gameCountOf(a));
      } catch (err) {
        throw normalizeQueryError(err, "Failed to load providers");
      }
    },
    placeholderData: (previous) => previous,
  });
}

export default useLobbyProviders;
